<template>
  <div class="tags-view" @contextmenu.prevent>
    <span
      v-show="showScrollBtns"
      class="tags-nav-btn"
      :class="{ disabled: !canScrollLeft }"
      title="向左"
      @click="scrollBy(-220)"
    >
      <i class="el-icon-arrow-left" />
    </span>

    <div ref="scroll" class="tags-scroll" @scroll="updateScrollState">
      <router-link
        v-for="tag in visitedViews"
        :key="tag.fullPath"
        ref="tag"
        :to="{ path: tag.path, query: tag.query }"
        class="tags-item"
        :class="{ active: isActive(tag) }"
        @click.middle.native.prevent="!isAffix(tag) && closeTag(tag)"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        <span class="tags-title">{{ tag.title }}</span>
        <span
          v-if="!isAffix(tag)"
          class="tags-close"
          @click.prevent.stop="closeTag(tag)"
        >
          <i class="el-icon-close" />
        </span>
      </router-link>
    </div>

    <span
      v-show="showScrollBtns"
      class="tags-nav-btn"
      :class="{ disabled: !canScrollRight }"
      title="向右"
      @click="scrollBy(220)"
    >
      <i class="el-icon-arrow-right" />
    </span>

    <el-dropdown
      class="tags-ops"
      trigger="click"
      placement="bottom-end"
      @command="onOpsCommand"
    >
      <span class="tags-ops-btn" title="标签页操作">
        <i class="el-icon-arrow-down" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="closeCurrent" :disabled="isAffix(currentView)">
          关闭当前标签页
        </el-dropdown-item>
        <el-dropdown-item command="closeOthers">关闭其它标签页</el-dropdown-item>
        <el-dropdown-item command="closeAll">关闭全部标签页</el-dropdown-item>
        <el-dropdown-item command="refresh" divided>刷新当前标签页</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <ul v-show="menuVisible" class="tags-menu" :style="menuStyle">
      <li @click="refreshSelected">刷新</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelected">关闭</li>
      <li @click="closeOthers">关闭其他</li>
      <li @click="closeAll">关闭全部</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TagsView',
  data() {
    return {
      menuVisible: false,
      menuStyle: { left: '0', top: '0' },
      selectedTag: {},
      showScrollBtns: false,
      canScrollLeft: false,
      canScrollRight: false
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    currentView() {
      return this.toView(this.$route)
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.addTag(route)
        this.$nextTick(() => {
          this.moveToActive()
          this.updateScrollState()
        })
      }
    },
    visitedViews() {
      this.$nextTick(() => this.updateScrollState())
    },
    menuVisible(val) {
      if (val) {
        document.addEventListener('click', this.closeMenu)
      } else {
        document.removeEventListener('click', this.closeMenu)
      }
    }
  },
  created() {
    this.$store.dispatch('tagsView/ensureHomeAffix')
  },
  mounted() {
    window.addEventListener('resize', this.updateScrollState)
    this.$nextTick(() => this.updateScrollState())
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu)
    window.removeEventListener('resize', this.updateScrollState)
  },
  methods: {
    isActive(tag) {
      return tag && tag.fullPath === this.$route.fullPath
    },
    isAffix(tag) {
      if (!tag) return false
      if (tag.affix) return true
      return tag.name === 'Home' || tag.path === '/home' || tag.fullPath === '/home'
    },
    resolveTitle(route) {
      if (route.meta && route.meta.title) return route.meta.title
      return route.name || '未命名'
    },
    toView(route) {
      return {
        fullPath: route.fullPath,
        path: route.path,
        name: route.name,
        title: this.resolveTitle(route),
        query: route.query || {},
        affix: !!(route.meta && route.meta.affix),
        noCache: !!(route.meta && route.meta.noCache)
      }
    },
    addTag(route) {
      if (!route || route.path === '/login') return
      if (!route.name && route.path === '/') return
      this.$store.dispatch('tagsView/addView', this.toView(route))
    },
    async closeTag(tag) {
      if (this.isAffix(tag)) return
      const { visitedViews } = await this.$store.dispatch('tagsView/delView', tag)
      if (this.isActive(tag)) {
        this.toLastView(visitedViews)
      }
      this.$nextTick(() => this.updateScrollState())
    },
    toLastView(visitedViews) {
      const latest = visitedViews.slice(-1)[0]
      if (latest) {
        this.$router.push({ path: latest.path, query: latest.query })
      } else {
        this.$router.push('/home')
      }
    },
    updateScrollState() {
      const scroller = this.$refs.scroll
      if (!scroller) return
      const max = scroller.scrollWidth - scroller.clientWidth
      this.showScrollBtns = max > 2
      this.canScrollLeft = scroller.scrollLeft > 2
      this.canScrollRight = scroller.scrollLeft < max - 2
    },
    scrollBy(delta) {
      const scroller = this.$refs.scroll
      if (!scroller) return
      scroller.scrollBy({ left: delta, behavior: 'smooth' })
      // smooth scroll 结束后再算一次状态
      window.setTimeout(() => this.updateScrollState(), 280)
    },
    moveToActive() {
      const tags = this.$refs.tag
      if (!tags || !tags.length) return
      const list = Array.isArray(tags) ? tags : [tags]
      const active = list.find(t => t.to && (t.to.path + this.queryString(t.to.query)) === this.$route.fullPath)
        || list.find(t => t.$el && t.$el.classList.contains('active'))
      if (!active || !active.$el) return
      const scroller = this.$refs.scroll
      if (!scroller) return
      const el = active.$el
      const left = el.offsetLeft
      const right = left + el.offsetWidth
      if (left < scroller.scrollLeft) {
        scroller.scrollLeft = Math.max(0, left - 8)
      } else if (right > scroller.scrollLeft + scroller.clientWidth) {
        scroller.scrollLeft = right - scroller.clientWidth + 8
      }
      this.updateScrollState()
    },
    queryString(query) {
      const q = query || {}
      const keys = Object.keys(q)
      if (!keys.length) return ''
      return '?' + keys.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(q[k] == null ? '' : q[k])).join('&')
    },
    openMenu(tag, e) {
      const menuMinWidth = 108
      const offsetLeft = this.$el.getBoundingClientRect().left
      const left = e.clientX - offsetLeft + 6
      const maxLeft = this.$el.offsetWidth - menuMinWidth - 36
      this.menuStyle = {
        left: Math.max(0, Math.min(left, maxLeft)) + 'px',
        top: e.clientY - this.$el.getBoundingClientRect().top + 6 + 'px'
      }
      this.selectedTag = tag
      this.menuVisible = true
    },
    closeMenu() {
      this.menuVisible = false
    },
    onOpsCommand(cmd) {
      this.selectedTag = this.currentView
      if (cmd === 'closeCurrent') this.closeSelected()
      else if (cmd === 'closeOthers') this.closeOthers()
      else if (cmd === 'closeAll') this.closeAll()
      else if (cmd === 'refresh') this.refreshSelected()
    },
    async refreshSelected() {
      this.closeMenu()
      await this.$store.dispatch('tagsView/refreshView')
    },
    closeSelected() {
      this.closeMenu()
      const tag = this.selectedTag && this.selectedTag.fullPath
        ? this.selectedTag
        : this.currentView
      if (tag && !this.isAffix(tag)) {
        this.closeTag(tag)
      }
    },
    async closeOthers() {
      this.closeMenu()
      const tag = this.selectedTag && this.selectedTag.fullPath
        ? this.selectedTag
        : this.currentView
      await this.$store.dispatch('tagsView/delOthersViews', tag)
      if (tag.fullPath !== this.$route.fullPath) {
        this.$router.push({ path: tag.path, query: tag.query })
      }
      this.$nextTick(() => this.updateScrollState())
    },
    async closeAll() {
      this.closeMenu()
      const { visitedViews } = await this.$store.dispatch('tagsView/delAllViews')
      if (visitedViews.length) {
        this.toLastView(visitedViews)
      } else {
        this.$router.push('/home')
      }
      this.$nextTick(() => this.updateScrollState())
    }
  }
}
</script>

<style scoped>
.tags-view {
  position: relative;
  display: flex;
  align-items: center;
  height: 36px;
  padding: 0 6px 0 10px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}
.tags-scroll {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  height: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.tags-scroll::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.tags-nav-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 26px;
  margin: 0 2px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
  flex-shrink: 0;
  user-select: none;
}
.tags-nav-btn:hover:not(.disabled) {
  color: #1d4ed8;
  border-color: #bfdbfe;
  background: #eff6ff;
}
.tags-nav-btn.disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.tags-ops {
  flex-shrink: 0;
  margin-left: 4px;
}
.tags-ops-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 26px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
}
.tags-ops-btn:hover {
  color: #1d4ed8;
  border-color: #bfdbfe;
  background: #eff6ff;
}
.tags-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 180px;
  height: 26px;
  padding: 0 8px 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  text-decoration: none;
  flex-shrink: 0;
}
.tags-item:hover {
  color: #1d4ed8;
  border-color: #bfdbfe;
  background: #eff6ff;
}
.tags-item.active {
  color: #1e40af;
  background: #dbeafe;
  border-color: #93c5fd;
  font-weight: 600;
}
.tags-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tags-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  color: #94a3b8;
  flex-shrink: 0;
}
.tags-close:hover {
  background: #94a3b8;
  color: #fff;
}
.tags-menu {
  position: absolute;
  z-index: 20;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
  min-width: 108px;
}
.tags-menu li {
  padding: 7px 14px;
  font-size: 12px;
  color: #334155;
  cursor: pointer;
}
.tags-menu li:hover {
  background: #eff6ff;
  color: #1d4ed8;
}
</style>
